import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { QuestionBase } from '../controls/question-base';

@Component({
  selector: 'app-dynamic-form-question',
  templateUrl: './dynamic-form-question.component.html',
  styleUrls: ['./dynamic-form-question.component.less']
})
export class DynamicFormQuestionComponent implements OnInit {
  @Input() question!: QuestionBase<string>;
  @Input() form!: FormGroup;
  @Input() code = 1; // 0表示新建/编辑  1表示巡检模板预览  2表示巡检工单预览
  @Output() nzDeleteVote = new EventEmitter<any>();
  @Output() nzEditVote = new EventEmitter<any>();
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: false,
    hidePreviewIconInNonImage: false
  };
  files = null;
  images: any[] = [];
  constructor() {

  }

  ngOnInit(): void {
    if(this.question != undefined && this.question != null){
      if ( this.question.ptctNo === 'upload' && !this.isEmpty(this.question.value)){
        if(this.form != null && this.form != undefined){
          this.form.get(this.question.key).setValue(this.question.value);
          const files: any[] = [];
          const  imageStrList = this.question.value.split(',');
          imageStrList.forEach(( item: any, index) => {
            const image =  item.split('&');
            files.push({
              uid: `${index}`,
              status: 'done',
              url: image[1]
            });
          } );
          this.images = files;
        }
      }
    }
  }
  delete(){
    this.nzDeleteVote.emit(this.question.key);
  }
  edit(){
    this.nzEditVote.emit(this.question.key);
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
  get isValid() { return this.form.controls[this.question.key].valid; }

  getShowTime(format){
    if (this.isEmpty(format)){
      return false;
    }else{
      const ls = format.split(' ');
      if (ls.length === 1){
        return false;
      }else{
        return { nzFormat: ls[1] };
      }
    }
  }
}
